type PromoDisplayInput = {
  couponApplied: boolean;
  hasVisibleDiscount: boolean;
  showOfferToggle: boolean;
};

export function getPromoDisplayState({
  couponApplied,
  hasVisibleDiscount,
  showOfferToggle,
}: PromoDisplayInput) {
  const showConfirmation = couponApplied && hasVisibleDiscount;

  return {
    showConfirmation,
    showSection: !couponApplied || showConfirmation || showOfferToggle,
  };
}
